<script>
    import closeIcon from './closeIcon';

    export default {
        name: 'tuitionTable',

        components: {closeIcon},

        props: {
            degrees: null,
            disableClearSelectionButton: {
                default: false
            },
            isCalc: {
                default: false
            },
            selectedDegree: null,
            isUndergrad: null
        },

        mounted() {

        },

        computed: {
            selectedDegreeId: function() {
                return this.selectedDegree ? this.selectedDegree.id : null
            }
        },

        methods: {

          selectDegree(id) {

            if(!this.isCalc) return false;

            this.$emit('select-degree', id);
          }

        }

    }
</script>

<template>
    <div class="a-tableWrapper" >
        <div class="a-tableWrapperSlider">
            <table class="a-table--responsive a-table tf-table tf-table--tuition" :class="{active:isCalc}">
                <thead>
                <tr>
                    <th v-if="isCalc"></th>
                    <th>Degree Program</th>
                    <th>Full-Time Tuition (Per Semester)</th>
                    <th>Full-Time Credit Range</th>
                    <th>Per-Credit Tuition</th>
                    <th v-if="!isUndergrad">Maintenance of Status</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="degree in degrees" :key="degree.id" :class="{highlight:degree.id === selectedDegreeId}" >
                    <td v-if="isCalc" class="tableCheckBox" @click="selectDegree(degree.id)" >
                        <div><span></span></div>
                    </td>
                    <td>{{degree.fullname}}</td>
                    <td>{{degree.fullTimeTuition | toCurrency}}</td>
                    <td>{{degree.ftCreditRange || 'N/A'}}</td>
                    <td>{{degree.perCreditTuition | toCurrency}}</td>
                    <td v-if="!isUndergrad">{{degree.maintenance | toCurrency}}</td>
                    <td v-else ></td>
                </tr>
                </tbody>
            </table>
            <div v-if="isCalc && selectedDegree && !disableClearSelectionButton" @click="selectDegree(selectedDegreeId)" class="tf-clearSelection"><closeIcon />Clear selection</div>
        </div>
    </div>
</template>
